import { render, staticRenderFns } from "./SiblingInformationTableForm.vue?vue&type=template&id=69fdb26c"
import script from "./SiblingInformationTableForm.vue?vue&type=script&lang=js"
export * from "./SiblingInformationTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports